import { TEXT_HTML_REQUEST_HEADER, STORE_HEADER_SERVICES_URL } from "../../common/store-header-services-constants";
export function fetchStoresDecreased(successCallback, errorCallback) {
  lm.fetch({
    url: STORE_HEADER_SERVICES_URL + '/contextlayer/decreased-view',
    method: 'GET',
    credentials: 'same-origin',
    headers: TEXT_HTML_REQUEST_HEADER,
    success: successCallback,
    error: errorCallback
  });
}